import { ComponentProps } from "react";
import { styled } from "~/application/theme";

export type IconProps = ComponentProps<typeof Icon>;

export const Icon = styled("svg", {
  // Reset
  boxSizing: "border-box",
  display: "flex",
  alignItems: "center",
  flexShrink: 0,

  variants: {
    size: {
      smlg: {
        size: "$3",
      },
      sm: {
        size: "$4",
      },
      md: {
        size: "$5",
      },
      lg: {
        size: "$8",
      },
      xl: {
        size: "$10",
      },
      "2xl": {
        size: "$12",
      },
      "3xl": {
        size: "$16",
      },
      "4xl": {
        size: "$20",
      },
      "5xl": {
        size: "$24",
      },
      "6xl": {
        size: "$32",
      },
    },
    variant: {
      primary: {
        fill: "$primary-base",
      },
      "primary-dark": {
        fill: "$primary-dark",
      },
      black: {
        fill: "$neutrals-black",
      },
      light: {
        fill: "$neutrals-light",
      },
      dark: {
        fill: "$neutrals-dark",
      },
      darkest: {
        fill: "$neutrals-darkest",
      },
      white: {
        fill: "$neutrals-white",
        color: "$neutrals-white",
      },
      warning: {
        fill: "$warning-base",
      },
      "warning-dark": {
        fill: "$warning-dark",
      },
      error: {
        fill: "$error-base",
      },
      "error-light": {
        fill: "$error-light",
      },
      success: {
        fill: "$success-base",
      },
      "neutral-50": {
        fill: "$neutral-50",
      },
      "neutral-100": {
        fill: "$neutral-100",
      },
      "neutral-200": {
        fill: "$neutral-200",
      },
      "neutral-300": {
        fill: "$neutral-300",
      },
      "neutral-400": {
        fill: "$neutral-400",
      },
      "neutral-500": {
        fill: "$neutral-500",
      },
      "neutral-600": {
        fill: "$neutral-600",
      },
      "neutral-700": {
        fill: "$neutral-700",
      },
      "neutral-800": {
        fill: "$neutral-800",
      },
      "neutral-900": {
        fill: "$neutral-900",
      },
      "primary-50": {
        fill: "$primary-50",
      },
      "primary-100": {
        fill: "$primary-100",
      },
      "primary-200": {
        fill: "$primary-200",
      },
      "primary-300": {
        fill: "$primary-300",
      },
      "primary-400": {
        fill: "$primary-400",
      },
      "primary-500": {
        fill: "$primary-500",
      },
      "primary-600": {
        fill: "$primary-600",
      },
      "primary-700": {
        fill: "$primary-700",
      },
      "primary-800": {
        fill: "$primary-800",
      },
      "primary-900": {
        fill: "$primary-900",
      },
      "warning-50": {
        fill: "$warning-50",
      },
      "warning-100": {
        fill: "$warning-100",
      },
      "warning-200": {
        fill: "$warning-200",
      },
      "warning-300": {
        fill: "$warning-300",
      },
      "warning-400": {
        fill: "$warning-400",
      },
      "warning-500": {
        fill: "$warning-500",
      },
      "warning-600": {
        fill: "$warning-600",
      },
      "warning-700": {
        fill: "$warning-700",
      },
      "warning-800": {
        fill: "$warning-800",
      },
      "warning-900": {
        fill: "$warning-900",
      },
      "danger-50": {
        fill: "$danger-50",
      },
      "danger-100": {
        fill: "$danger-100",
      },
      "danger-200": {
        fill: "$danger-200",
      },
      "danger-300": {
        fill: "$danger-300",
      },
      "danger-400": {
        fill: "$danger-400",
      },
      "danger-500": {
        fill: "$danger-500",
      },
      "danger-600": {
        fill: "$danger-600",
      },
      "danger-700": {
        fill: "$danger-700",
      },
      "danger-800": {
        fill: "$danger-800",
      },
      "danger-900": {
        fill: "$danger-900",
      },
    },
  },

  defaultVariants: {
    size: "md",
  },
});
